export enum SessionStorageKeys {
  OidcUserPrefix = 'oidc.user',
  LoginPostAuthUrl = 'Login.PostAuthUrl',
}
